
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 2.5a7.5 7.5 0 107.5 7.5A7.508 7.508 0 0010 2.5zm.68 11H9.33V8.56h1.35zm.19-6.521a.831.831 0 01-.86.8h-.037a.842.842 0 01-.843-.839v-.036a.852.852 0 01.879-.824h.039a.841.841 0 01.821.86z"}})])
          )
        }
      }
    